import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import { createContext, createElement, Component } from 'react';
import { object, func, node, string, bool, number, oneOfType, arrayOf, any } from 'prop-types';
import { InvariantError, invariant } from 'ts-invariant';
import { __extends, __assign, __rest } from 'tslib';
import { ApolloError, NetworkStatus } from 'apollo-client';
import isEqual from 'lodash.isequal';
import hoistNonReactStatics from 'hoist-non-react-statics';
var ApolloContext = createContext && createContext(undefined);

var ApolloConsumer = function ApolloConsumer(props, legacyContext) {
  function finish(context) {
    if (!context || !context.client) {
      throw process.env.NODE_ENV === "production" ? new InvariantError() : new InvariantError('Could not find "client" in the context of ApolloConsumer. ' + 'Wrap the root component in an <ApolloProvider>.');
    }

    return props.children(context.client);
  }

  return ApolloContext ? createElement(ApolloContext.Consumer, null, finish) : finish(legacyContext);
};

ApolloConsumer.contextTypes = {
  client: object.isRequired
};
ApolloConsumer.propTypes = {
  children: func.isRequired
};

var ApolloProvider = function (_super) {
  __extends(ApolloProvider, _super);

  function ApolloProvider(props, context) {
    var _this = _super.call(this, props, context) || this;

    _this.operations = new Map();
    process.env.NODE_ENV === "production" ? invariant(props.client) : invariant(props.client, 'ApolloProvider was not passed a client instance. Make ' + 'sure you pass in your client via the "client" prop.');

    if (!props.client.__operations_cache__) {
      props.client.__operations_cache__ = _this.operations;
    }

    return _this;
  }

  ApolloProvider.prototype.getChildContext = function () {
    return {
      client: this.props.client,
      operations: this.props.client.__operations_cache__
    };
  };

  ApolloProvider.prototype.render = function () {
    return ApolloContext ? createElement(ApolloContext.Provider, {
      value: this.getChildContext()
    }, this.props.children) : this.props.children;
  };

  ApolloProvider.propTypes = {
    client: object.isRequired,
    children: node.isRequired
  };
  ApolloProvider.childContextTypes = {
    client: object.isRequired,
    operations: object
  };
  return ApolloProvider;
}(Component);

var DocumentType;

(function (DocumentType) {
  DocumentType[DocumentType["Query"] = 0] = "Query";
  DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
  DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));

var cache = new Map();

function parser(document) {
  var cached = cache.get(document);
  if (cached) return cached;
  var variables, type, name;
  process.env.NODE_ENV === "production" ? invariant(!!document && !!document.kind) : invariant(!!document && !!document.kind, "Argument of " + document + " passed to parser was not a valid GraphQL " + "DocumentNode. You may need to use 'graphql-tag' or another method " + "to convert your operation into a document");
  var fragments = document.definitions.filter(function (x) {
    return x.kind === 'FragmentDefinition';
  });
  var queries = document.definitions.filter(function (x) {
    return x.kind === 'OperationDefinition' && x.operation === 'query';
  });
  var mutations = document.definitions.filter(function (x) {
    return x.kind === 'OperationDefinition' && x.operation === 'mutation';
  });
  var subscriptions = document.definitions.filter(function (x) {
    return x.kind === 'OperationDefinition' && x.operation === 'subscription';
  });
  process.env.NODE_ENV === "production" ? invariant(!fragments.length || queries.length || mutations.length || subscriptions.length) : invariant(!fragments.length || queries.length || mutations.length || subscriptions.length, "Passing only a fragment to 'graphql' is not yet supported. " + "You must include a query, subscription or mutation as well");
  process.env.NODE_ENV === "production" ? invariant(queries.length + mutations.length + subscriptions.length <= 1) : invariant(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " + (document + " had " + queries.length + " queries, " + subscriptions.length + " ") + ("subscriptions and " + mutations.length + " mutations. ") + "You can use 'compose' to join multiple operation types to a component");
  type = queries.length ? DocumentType.Query : DocumentType.Mutation;
  if (!queries.length && !mutations.length) type = DocumentType.Subscription;
  var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
  process.env.NODE_ENV === "production" ? invariant(definitions.length === 1) : invariant(definitions.length === 1, "react-apollo only supports one definition per HOC. " + document + " had " + (definitions.length + " definitions. ") + "You can use 'compose' to join multiple operation types to a component");
  var definition = definitions[0];
  variables = definition.variableDefinitions || [];

  if (definition.name && definition.name.kind === 'Name') {
    name = definition.name.value;
  } else {
    name = 'data';
  }

  var payload = {
    name: name,
    type: type,
    variables: variables
  };
  cache.set(document, payload);
  return payload;
}

function getClient(props, context) {
  var client = props.client || context.client;
  process.env.NODE_ENV === "production" ? invariant(!!client) : invariant(!!client, 'Could not find "client" in the context or passed in as a prop. ' + 'Wrap the root component in an <ApolloProvider>, or pass an ' + 'ApolloClient instance in via props.');
  return client;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }

  return x !== x && y !== y;
}

function isObject(obj) {
  return obj !== null && typeof obj === "object";
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (!isObject(objA) || !isObject(objB)) {
    return false;
  }

  var keys = Object.keys(objA);

  if (keys.length !== Object.keys(objB).length) {
    return false;
  }

  return keys.every(function (key) {
    return hasOwnProperty.call(objB, key) && is(objA[key], objB[key]);
  });
}

function observableQueryFields(observable) {
  var fields = {
    variables: observable.variables,
    refetch: observable.refetch.bind(observable),
    fetchMore: observable.fetchMore.bind(observable),
    updateQuery: observable.updateQuery.bind(observable),
    startPolling: observable.startPolling.bind(observable),
    stopPolling: observable.stopPolling.bind(observable),
    subscribeToMore: observable.subscribeToMore.bind(observable)
  };
  return fields;
}

var Query = function (_super) {
  __extends(Query, _super);

  function Query(props, context) {
    var _this = _super.call(this, props, context) || this;

    _this.hasMounted = false;
    _this.lastRenderedResult = null;

    _this.startQuerySubscription = function () {
      if (_this.querySubscription) return;
      _this.querySubscription = _this.queryObservable.subscribe({
        next: function next(result) {
          if (_this.lastRenderedResult && _this.lastRenderedResult.loading === result.loading && _this.lastRenderedResult.networkStatus === result.networkStatus && shallowEqual(_this.lastRenderedResult.data, result.data)) {
            return;
          }

          _this.updateCurrentData();
        },
        error: function error(_error) {
          _this.resubscribeToQuery();

          if (!_error.hasOwnProperty('graphQLErrors')) throw _error;

          _this.updateCurrentData();
        }
      });
    };

    _this.removeQuerySubscription = function () {
      if (_this.querySubscription) {
        _this.querySubscription.unsubscribe();

        delete _this.lastRenderedResult;
        delete _this.querySubscription;
      }
    };

    _this.updateCurrentData = function () {
      _this.handleErrorOrCompleted();

      if (_this.hasMounted) _this.forceUpdate();
    };

    _this.handleErrorOrCompleted = function () {
      var result = _this.queryObservable.currentResult();

      var data = result.data,
          loading = result.loading,
          error = result.error;
      var _a = _this.props,
          onCompleted = _a.onCompleted,
          onError = _a.onError;

      if (onCompleted && !loading && !error) {
        onCompleted(data);
      } else if (onError && !loading && error) {
        onError(error);
      }
    };

    _this.getQueryResult = function () {
      var result = {
        data: Object.create(null)
      };
      Object.assign(result, observableQueryFields(_this.queryObservable));

      if (_this.props.skip) {
        result = __assign({}, result, {
          data: undefined,
          error: undefined,
          loading: false
        });
      } else {
        var currentResult = _this.queryObservable.currentResult();

        var loading = currentResult.loading,
            partial = currentResult.partial,
            networkStatus = currentResult.networkStatus,
            errors = currentResult.errors;
        var error = currentResult.error;

        if (errors && errors.length > 0) {
          error = new ApolloError({
            graphQLErrors: errors
          });
        }

        var fetchPolicy = _this.queryObservable.options.fetchPolicy;
        Object.assign(result, {
          loading: loading,
          networkStatus: networkStatus,
          error: error
        });
        var previousData = _this.lastRenderedResult ? _this.lastRenderedResult.data : {};

        if (loading) {
          Object.assign(result.data, previousData, currentResult.data);
        } else if (error) {
          Object.assign(result, {
            data: (_this.queryObservable.getLastResult() || {}).data
          });
        } else if (fetchPolicy === 'no-cache' && Object.keys(currentResult.data).length === 0) {
          result.data = previousData;
        } else {
          var partialRefetch = _this.props.partialRefetch;

          if (partialRefetch && currentResult.data !== null && typeof currentResult.data === 'object' && Object.keys(currentResult.data).length === 0 && partial && fetchPolicy !== 'cache-only') {
            Object.assign(result, {
              loading: true,
              networkStatus: NetworkStatus.loading
            });
            result.refetch();
            _this.lastRenderedResult = result;
            return result;
          }

          Object.assign(result.data, currentResult.data);
        }
      }

      if (!_this.querySubscription) {
        var oldRefetch_1 = result.refetch;

        result.refetch = function (args) {
          if (_this.querySubscription) {
            return oldRefetch_1(args);
          } else {
            return new Promise(function (r, f) {
              _this.refetcherQueue = {
                resolve: r,
                reject: f,
                args: args
              };
            });
          }
        };
      }

      setTimeout(function () {
        if (_this.queryObservable.resetQueryStoreErrors) {
          _this.queryObservable.resetQueryStoreErrors();
        } else {
          var _a = _this.queryObservable,
              queryManager = _a.queryManager,
              queryId = _a.queryId;
          var queryStore = queryManager.queryStore.get(queryId);

          if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
          }
        }
      });
      result.client = _this.client;
      _this.lastRenderedResult = result;
      return result;
    };

    _this.client = getClient(props, context);

    _this.initializeQueryObservable(props);

    return _this;
  }

  Query.prototype.fetchData = function () {
    if (this.props.skip) return false;

    var _a = this.props,
        children = _a.children,
        ssr = _a.ssr,
        displayName = _a.displayName,
        skip = _a.skip,
        client = _a.client,
        onCompleted = _a.onCompleted,
        onError = _a.onError,
        partialRefetch = _a.partialRefetch,
        opts = __rest(_a, ["children", "ssr", "displayName", "skip", "client", "onCompleted", "onError", "partialRefetch"]);

    var fetchPolicy = opts.fetchPolicy;
    if (ssr === false) return false;

    if (fetchPolicy === 'network-only' || fetchPolicy === 'cache-and-network') {
      fetchPolicy = 'cache-first';
    }

    var observable = this.client.watchQuery(__assign({}, opts, {
      fetchPolicy: fetchPolicy
    }));

    if (this.context && this.context.renderPromises) {
      this.context.renderPromises.registerSSRObservable(this, observable);
    }

    var result = this.queryObservable.currentResult();
    return result.loading ? observable.result() : false;
  };

  Query.prototype.componentDidMount = function () {
    this.hasMounted = true;
    if (this.props.skip) return;
    this.startQuerySubscription();

    if (this.refetcherQueue) {
      var _a = this.refetcherQueue,
          args = _a.args,
          resolve = _a.resolve,
          reject = _a.reject;
      this.queryObservable.refetch(args).then(resolve)["catch"](reject);
    }
  };

  Query.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
    if (nextProps.skip && !this.props.skip) {
      this.queryObservable.resetLastResults();
      this.removeQuerySubscription();
      return;
    }

    var nextClient = getClient(nextProps, nextContext);

    if (shallowEqual(this.props, nextProps) && this.client === nextClient) {
      return;
    }

    if (this.client !== nextClient) {
      this.client = nextClient;
      this.removeQuerySubscription();
      this.queryObservable = null;
    }

    if (this.props.query !== nextProps.query) {
      this.queryObservable.resetLastResults();
      this.removeQuerySubscription();
    }

    this.updateQuery(nextProps);
    if (nextProps.skip) return;
    this.startQuerySubscription();
  };

  Query.prototype.componentWillUnmount = function () {
    this.removeQuerySubscription();
    this.hasMounted = false;
  };

  Query.prototype.componentDidUpdate = function (prevProps) {
    var isDiffRequest = !isEqual(prevProps.query, this.props.query) || !isEqual(prevProps.variables, this.props.variables);

    if (isDiffRequest) {
      this.handleErrorOrCompleted();
    }
  };

  Query.prototype.render = function () {
    var _this = this;

    var context = this.context;

    var finish = function finish() {
      return _this.props.children(_this.getQueryResult());
    };

    if (context && context.renderPromises) {
      return context.renderPromises.addQueryPromise(this, finish);
    }

    return finish();
  };

  Query.prototype.extractOptsFromProps = function (props) {
    this.operation = parser(props.query);
    process.env.NODE_ENV === "production" ? invariant(this.operation.type === DocumentType.Query) : invariant(this.operation.type === DocumentType.Query, "The <Query /> component requires a graphql query, but got a " + (this.operation.type === DocumentType.Mutation ? 'mutation' : 'subscription') + ".");
    var displayName = props.displayName || 'Query';
    return __assign({}, props, {
      displayName: displayName,
      context: props.context || {},
      metadata: {
        reactComponent: {
          displayName: displayName
        }
      }
    });
  };

  Query.prototype.initializeQueryObservable = function (props) {
    var opts = this.extractOptsFromProps(props);
    this.setOperations(opts);

    if (this.context && this.context.renderPromises) {
      this.queryObservable = this.context.renderPromises.getSSRObservable(this);
    }

    if (!this.queryObservable) {
      this.queryObservable = this.client.watchQuery(opts);
    }
  };

  Query.prototype.setOperations = function (props) {
    if (this.context.operations) {
      this.context.operations.set(this.operation.name, {
        query: props.query,
        variables: props.variables
      });
    }
  };

  Query.prototype.updateQuery = function (props) {
    if (!this.queryObservable) {
      this.initializeQueryObservable(props);
    } else {
      this.setOperations(props);
    }

    this.queryObservable.setOptions(this.extractOptsFromProps(props))["catch"](function () {
      return null;
    });
  };

  Query.prototype.resubscribeToQuery = function () {
    this.removeQuerySubscription();
    var lastError = this.queryObservable.getLastError();
    var lastResult = this.queryObservable.getLastResult();
    this.queryObservable.resetLastResults();
    this.startQuerySubscription();
    Object.assign(this.queryObservable, {
      lastError: lastError,
      lastResult: lastResult
    });
  };

  Query.contextTypes = {
    client: object,
    operations: object,
    renderPromises: object
  };
  Query.propTypes = {
    client: object,
    children: func.isRequired,
    fetchPolicy: string,
    notifyOnNetworkStatusChange: bool,
    onCompleted: func,
    onError: func,
    pollInterval: number,
    query: object.isRequired,
    variables: object,
    ssr: bool,
    partialRefetch: bool,
    returnPartialData: bool
  };
  return Query;
}(Component);

var initialState = {
  loading: false,
  called: false,
  error: undefined,
  data: undefined
};

var Mutation = function (_super) {
  __extends(Mutation, _super);

  function Mutation(props, context) {
    var _this = _super.call(this, props, context) || this;

    _this.hasMounted = false;

    _this.runMutation = function (options) {
      if (options === void 0) {
        options = {};
      }

      _this.onMutationStart();

      var mutationId = _this.generateNewMutationId();

      return _this.mutate(options).then(function (response) {
        _this.onMutationCompleted(response, mutationId);

        return response;
      })["catch"](function (e) {
        _this.onMutationError(e, mutationId);

        if (!_this.props.onError) throw e;
      });
    };

    _this.mutate = function (options) {
      var _a = _this.props,
          mutation = _a.mutation,
          variables = _a.variables,
          optimisticResponse = _a.optimisticResponse,
          update = _a.update,
          _b = _a.context,
          context = _b === void 0 ? {} : _b,
          _c = _a.awaitRefetchQueries,
          awaitRefetchQueries = _c === void 0 ? false : _c,
          fetchPolicy = _a.fetchPolicy;

      var mutateOptions = __assign({}, options);

      var refetchQueries = mutateOptions.refetchQueries || _this.props.refetchQueries;

      if (refetchQueries && refetchQueries.length && Array.isArray(refetchQueries)) {
        refetchQueries = refetchQueries.map(function (x) {
          if (typeof x === 'string' && _this.context.operations) return _this.context.operations.get(x) || x;
          return x;
        });
        delete mutateOptions.refetchQueries;
      }

      var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
      delete mutateOptions.variables;
      return _this.client.mutate(__assign({
        mutation: mutation,
        optimisticResponse: optimisticResponse,
        refetchQueries: refetchQueries,
        awaitRefetchQueries: awaitRefetchQueries,
        update: update,
        context: context,
        fetchPolicy: fetchPolicy,
        variables: mutateVariables
      }, mutateOptions));
    };

    _this.onMutationStart = function () {
      if (!_this.state.loading && !_this.props.ignoreResults) {
        _this.setState({
          loading: true,
          error: undefined,
          data: undefined,
          called: true
        });
      }
    };

    _this.onMutationCompleted = function (response, mutationId) {
      var _a = _this.props,
          onCompleted = _a.onCompleted,
          ignoreResults = _a.ignoreResults;
      var data = response.data,
          errors = response.errors;
      var error = errors && errors.length > 0 ? new ApolloError({
        graphQLErrors: errors
      }) : undefined;

      var callOncomplete = function callOncomplete() {
        return onCompleted ? onCompleted(data) : null;
      };

      if (_this.hasMounted && _this.isMostRecentMutation(mutationId) && !ignoreResults) {
        _this.setState({
          loading: false,
          data: data,
          error: error
        }, callOncomplete);
      } else {
        callOncomplete();
      }
    };

    _this.onMutationError = function (error, mutationId) {
      var onError = _this.props.onError;

      var callOnError = function callOnError() {
        return onError ? onError(error) : null;
      };

      if (_this.hasMounted && _this.isMostRecentMutation(mutationId)) {
        _this.setState({
          loading: false,
          error: error
        }, callOnError);
      } else {
        callOnError();
      }
    };

    _this.generateNewMutationId = function () {
      _this.mostRecentMutationId = _this.mostRecentMutationId + 1;
      return _this.mostRecentMutationId;
    };

    _this.isMostRecentMutation = function (mutationId) {
      return _this.mostRecentMutationId === mutationId;
    };

    _this.verifyDocumentIsMutation = function (mutation) {
      var operation = parser(mutation);
      process.env.NODE_ENV === "production" ? invariant(operation.type === DocumentType.Mutation) : invariant(operation.type === DocumentType.Mutation, "The <Mutation /> component requires a graphql mutation, but got a " + (operation.type === DocumentType.Query ? 'query' : 'subscription') + ".");
    };

    _this.client = getClient(props, context);

    _this.verifyDocumentIsMutation(props.mutation);

    _this.mostRecentMutationId = 0;
    _this.state = initialState;
    return _this;
  }

  Mutation.prototype.componentDidMount = function () {
    this.hasMounted = true;
  };

  Mutation.prototype.componentWillUnmount = function () {
    this.hasMounted = false;
  };

  Mutation.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
    var nextClient = getClient(nextProps, nextContext);

    if (shallowEqual(this.props, nextProps) && this.client === nextClient) {
      return;
    }

    if (this.props.mutation !== nextProps.mutation) {
      this.verifyDocumentIsMutation(nextProps.mutation);
    }

    if (this.client !== nextClient) {
      this.client = nextClient;
      this.setState(initialState);
    }
  };

  Mutation.prototype.render = function () {
    var children = this.props.children;
    var _a = this.state,
        loading = _a.loading,
        data = _a.data,
        error = _a.error,
        called = _a.called;
    var result = {
      called: called,
      loading: loading,
      data: data,
      error: error,
      client: this.client
    };
    return children(this.runMutation, result);
  };

  Mutation.contextTypes = {
    client: object,
    operations: object
  };
  Mutation.propTypes = {
    mutation: object.isRequired,
    variables: object,
    optimisticResponse: object,
    refetchQueries: oneOfType([arrayOf(oneOfType([string, object])), func]),
    awaitRefetchQueries: bool,
    update: func,
    children: func.isRequired,
    onCompleted: func,
    onError: func,
    fetchPolicy: string
  };
  return Mutation;
}(Component);

var Subscription = function (_super) {
  __extends(Subscription, _super);

  function Subscription(props, context) {
    var _this = _super.call(this, props, context) || this;

    _this.initialize = function (props) {
      if (_this.queryObservable) return;
      _this.queryObservable = _this.client.subscribe({
        query: props.subscription,
        variables: props.variables,
        fetchPolicy: props.fetchPolicy
      });
    };

    _this.startSubscription = function () {
      if (_this.querySubscription) return;
      _this.querySubscription = _this.queryObservable.subscribe({
        next: _this.updateCurrentData,
        error: _this.updateError,
        complete: _this.completeSubscription
      });
    };

    _this.getInitialState = function () {
      return {
        loading: true,
        error: undefined,
        data: undefined
      };
    };

    _this.updateCurrentData = function (result) {
      var _a = _this,
          client = _a.client,
          onSubscriptionData = _a.props.onSubscriptionData;

      _this.setState({
        data: result.data,
        loading: false,
        error: undefined
      });

      if (onSubscriptionData) onSubscriptionData({
        client: client,
        subscriptionData: result
      });
    };

    _this.updateError = function (error) {
      _this.setState({
        error: error,
        loading: false
      });
    };

    _this.completeSubscription = function () {
      var onSubscriptionComplete = _this.props.onSubscriptionComplete;
      if (onSubscriptionComplete) onSubscriptionComplete();

      _this.endSubscription();
    };

    _this.endSubscription = function () {
      if (_this.querySubscription) {
        _this.querySubscription.unsubscribe();

        delete _this.querySubscription;
      }
    };

    _this.client = getClient(props, context);

    _this.initialize(props);

    _this.state = _this.getInitialState();
    return _this;
  }

  Subscription.prototype.componentDidMount = function () {
    this.startSubscription();
  };

  Subscription.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
    var nextClient = getClient(nextProps, nextContext);

    if (shallowEqual(this.props.variables, nextProps.variables) && this.client === nextClient && this.props.subscription === nextProps.subscription) {
      return;
    }

    var shouldResubscribe = nextProps.shouldResubscribe;

    if (typeof shouldResubscribe === 'function') {
      shouldResubscribe = !!shouldResubscribe(this.props, nextProps);
    }

    var shouldNotResubscribe = shouldResubscribe === false;

    if (this.client !== nextClient) {
      this.client = nextClient;
    }

    if (!shouldNotResubscribe) {
      this.endSubscription();
      delete this.queryObservable;
      this.initialize(nextProps);
      this.startSubscription();
      this.setState(this.getInitialState());
      return;
    }

    this.initialize(nextProps);
    this.startSubscription();
  };

  Subscription.prototype.componentWillUnmount = function () {
    this.endSubscription();
  };

  Subscription.prototype.render = function () {
    var renderFn = this.props.children;
    if (!renderFn) return null;
    var result = Object.assign({}, this.state, {
      variables: this.props.variables
    });
    return renderFn(result);
  };

  Subscription.contextTypes = {
    client: object
  };
  Subscription.propTypes = {
    subscription: object.isRequired,
    variables: object,
    children: func,
    onSubscriptionData: func,
    onSubscriptionComplete: func,
    shouldResubscribe: oneOfType([func, bool])
  };
  return Subscription;
}(Component);

var defaultMapPropsToOptions = function defaultMapPropsToOptions() {
  return {};
};

var defaultMapPropsToSkip = function defaultMapPropsToSkip() {
  return false;
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function calculateVariablesFromProps(operation, props) {
  var variables = {};

  for (var _i = 0, _a = operation.variables; _i < _a.length; _i++) {
    var _b = _a[_i],
        variable = _b.variable,
        type = _b.type;
    if (!variable.name || !variable.name.value) continue;
    var variableName = variable.name.value;
    var variableProp = props[variableName];

    if (typeof variableProp !== 'undefined') {
      variables[variableName] = variableProp;
      continue;
    }

    if (type.kind !== 'NonNullType') {
      variables[variableName] = undefined;
    }
  }

  return variables;
}

var GraphQLBase = function (_super) {
  __extends(GraphQLBase, _super);

  function GraphQLBase(props) {
    var _this = _super.call(this, props) || this;

    _this.withRef = false;
    _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
    return _this;
  }

  GraphQLBase.prototype.getWrappedInstance = function () {
    process.env.NODE_ENV === "production" ? invariant(this.withRef) : invariant(this.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
    return this.wrappedInstance;
  };

  GraphQLBase.prototype.setWrappedInstance = function (ref) {
    this.wrappedInstance = ref;
  };

  return GraphQLBase;
}(Component);

function withQuery(document, operationOptions) {
  if (operationOptions === void 0) {
    operationOptions = {};
  }

  var operation = parser(document);
  var _a = operationOptions.options,
      options = _a === void 0 ? defaultMapPropsToOptions : _a,
      _b = operationOptions.skip,
      skip = _b === void 0 ? defaultMapPropsToSkip : _b,
      _c = operationOptions.alias,
      alias = _c === void 0 ? 'Apollo' : _c;
  var mapPropsToOptions = options;

  if (typeof mapPropsToOptions !== 'function') {
    mapPropsToOptions = function mapPropsToOptions() {
      return options;
    };
  }

  var mapPropsToSkip = skip;

  if (typeof mapPropsToSkip !== 'function') {
    mapPropsToSkip = function mapPropsToSkip() {
      return skip;
    };
  }

  var lastResultProps;
  return function (WrappedComponent) {
    var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";

    var GraphQL = function (_super) {
      __extends(GraphQL, _super);

      function GraphQL() {
        return _super !== null && _super.apply(this, arguments) || this;
      }

      GraphQL.prototype.render = function () {
        var _this = this;

        var props = this.props;
        var shouldSkip = mapPropsToSkip(props);
        var opts = shouldSkip ? Object.create(null) : __assign({}, mapPropsToOptions(props));

        if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
          opts.variables = calculateVariablesFromProps(operation, props);
        }

        return createElement(Query, __assign({}, opts, {
          displayName: graphQLDisplayName,
          skip: shouldSkip,
          query: document,
          warnUnhandledError: true
        }), function (_a) {
          var _b, _c;

          var _ = _a.client,
              data = _a.data,
              r = __rest(_a, ["client", "data"]);

          if (operationOptions.withRef) {
            _this.withRef = true;
            props = Object.assign({}, props, {
              ref: _this.setWrappedInstance
            });
          }

          if (shouldSkip) {
            return createElement(WrappedComponent, __assign({}, props, {}));
          }

          var result = Object.assign(r, data || {});
          var name = operationOptions.name || 'data';
          var childProps = (_b = {}, _b[name] = result, _b);

          if (operationOptions.props) {
            var newResult = (_c = {}, _c[name] = result, _c.ownProps = props, _c);
            lastResultProps = operationOptions.props(newResult, lastResultProps);
            childProps = lastResultProps;
          }

          return createElement(WrappedComponent, __assign({}, props, childProps));
        });
      };

      GraphQL.displayName = graphQLDisplayName;
      GraphQL.WrappedComponent = WrappedComponent;
      return GraphQL;
    }(GraphQLBase);

    return hoistNonReactStatics(GraphQL, WrappedComponent, {});
  };
}

function withMutation(document, operationOptions) {
  if (operationOptions === void 0) {
    operationOptions = {};
  }

  var operation = parser(document);
  var _a = operationOptions.options,
      options = _a === void 0 ? defaultMapPropsToOptions : _a,
      _b = operationOptions.alias,
      alias = _b === void 0 ? 'Apollo' : _b;
  var mapPropsToOptions = options;
  if (typeof mapPropsToOptions !== 'function') mapPropsToOptions = function mapPropsToOptions() {
    return options;
  };
  return function (WrappedComponent) {
    var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";

    var GraphQL = function (_super) {
      __extends(GraphQL, _super);

      function GraphQL() {
        return _super !== null && _super.apply(this, arguments) || this;
      }

      GraphQL.prototype.render = function () {
        var props = this.props;
        var opts = mapPropsToOptions(props);

        if (operationOptions.withRef) {
          this.withRef = true;
          props = Object.assign({}, props, {
            ref: this.setWrappedInstance
          });
        }

        if (!opts.variables && operation.variables.length > 0) {
          opts.variables = calculateVariablesFromProps(operation, props);
        }

        return createElement(Mutation, __assign({}, opts, {
          mutation: document,
          ignoreResults: true
        }), function (mutate, _a) {
          var _b, _c;

          var data = _a.data,
              r = __rest(_a, ["data"]);

          var result = Object.assign(r, data || {});
          var name = operationOptions.name || 'mutate';
          var resultName = operationOptions.name ? name + "Result" : 'result';
          var childProps = (_b = {}, _b[name] = mutate, _b[resultName] = result, _b);

          if (operationOptions.props) {
            var newResult = (_c = {}, _c[name] = mutate, _c[resultName] = result, _c.ownProps = props, _c);
            childProps = operationOptions.props(newResult);
          }

          return createElement(WrappedComponent, __assign({}, props, childProps));
        });
      };

      GraphQL.displayName = graphQLDisplayName;
      GraphQL.WrappedComponent = WrappedComponent;
      return GraphQL;
    }(GraphQLBase);

    return hoistNonReactStatics(GraphQL, WrappedComponent, {});
  };
}

function withSubscription(document, operationOptions) {
  if (operationOptions === void 0) {
    operationOptions = {};
  }

  var operation = parser(document);
  var _a = operationOptions.options,
      options = _a === void 0 ? defaultMapPropsToOptions : _a,
      _b = operationOptions.skip,
      skip = _b === void 0 ? defaultMapPropsToSkip : _b,
      _c = operationOptions.alias,
      alias = _c === void 0 ? 'Apollo' : _c,
      shouldResubscribe = operationOptions.shouldResubscribe;
  var mapPropsToOptions = options;
  if (typeof mapPropsToOptions !== 'function') mapPropsToOptions = function mapPropsToOptions() {
    return options;
  };
  var mapPropsToSkip = skip;
  if (typeof mapPropsToSkip !== 'function') mapPropsToSkip = function mapPropsToSkip() {
    return skip;
  };
  var lastResultProps;
  return function (WrappedComponent) {
    var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";

    var GraphQL = function (_super) {
      __extends(GraphQL, _super);

      function GraphQL(props) {
        var _this = _super.call(this, props) || this;

        _this.state = {
          resubscribe: false
        };
        return _this;
      }

      GraphQL.prototype.componentWillReceiveProps = function (nextProps) {
        if (!shouldResubscribe) return;
        this.setState({
          resubscribe: shouldResubscribe(this.props, nextProps)
        });
      };

      GraphQL.prototype.render = function () {
        var _this = this;

        var props = this.props;
        var shouldSkip = mapPropsToSkip(props);
        var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);

        if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
          opts.variables = calculateVariablesFromProps(operation, props);
        }

        return createElement(Subscription, __assign({}, opts, {
          displayName: graphQLDisplayName,
          skip: shouldSkip,
          subscription: document,
          shouldResubscribe: this.state.resubscribe
        }), function (_a) {
          var _b, _c;

          var data = _a.data,
              r = __rest(_a, ["data"]);

          if (operationOptions.withRef) {
            _this.withRef = true;
            props = Object.assign({}, props, {
              ref: _this.setWrappedInstance
            });
          }

          if (shouldSkip) {
            return createElement(WrappedComponent, __assign({}, props, {}));
          }

          var result = Object.assign(r, data || {});
          var name = operationOptions.name || 'data';
          var childProps = (_b = {}, _b[name] = result, _b);

          if (operationOptions.props) {
            var newResult = (_c = {}, _c[name] = result, _c.ownProps = props, _c);
            lastResultProps = operationOptions.props(newResult, lastResultProps);
            childProps = lastResultProps;
          }

          return createElement(WrappedComponent, __assign({}, props, childProps));
        });
      };

      GraphQL.displayName = graphQLDisplayName;
      GraphQL.WrappedComponent = WrappedComponent;
      return GraphQL;
    }(GraphQLBase);

    return hoistNonReactStatics(GraphQL, WrappedComponent, {});
  };
}

function graphql(document, operationOptions) {
  if (operationOptions === void 0) {
    operationOptions = {};
  }

  switch (parser(document).type) {
    case DocumentType.Mutation:
      return withMutation(document, operationOptions);

    case DocumentType.Subscription:
      return withSubscription(document, operationOptions);

    case DocumentType.Query:
    default:
      return withQuery(document, operationOptions);
  }
}

function getDisplayName$1(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withApollo(WrappedComponent, operationOptions) {
  if (operationOptions === void 0) {
    operationOptions = {};
  }

  var withDisplayName = "withApollo(" + getDisplayName$1(WrappedComponent) + ")";

  var WithApollo = function (_super) {
    __extends(WithApollo, _super);

    function WithApollo(props) {
      var _this = _super.call(this, props) || this;

      _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
      return _this;
    }

    WithApollo.prototype.getWrappedInstance = function () {
      process.env.NODE_ENV === "production" ? invariant(operationOptions.withRef) : invariant(operationOptions.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
      return this.wrappedInstance;
    };

    WithApollo.prototype.setWrappedInstance = function (ref) {
      this.wrappedInstance = ref;
    };

    WithApollo.prototype.render = function () {
      var _this = this;

      return createElement(ApolloConsumer, null, function (client) {
        var props = Object.assign({}, _this.props, {
          client: client,
          ref: operationOptions.withRef ? _this.setWrappedInstance : undefined
        });
        return createElement(WrappedComponent, __assign({}, props));
      });
    };

    WithApollo.displayName = withDisplayName;
    WithApollo.WrappedComponent = WrappedComponent;
    return WithApollo;
  }(Component);

  return hoistNonReactStatics(WithApollo, WrappedComponent, {});
}

function makeDefaultQueryInfo() {
  return {
    seen: false,
    observable: null
  };
}

var RenderPromises = function () {
  function RenderPromises() {
    this.queryPromises = new Map();
    this.queryInfoTrie = new Map();
  }

  RenderPromises.prototype.registerSSRObservable = function (queryInstance, observable) {
    this.lookupQueryInfo(queryInstance).observable = observable;
  };

  RenderPromises.prototype.getSSRObservable = function (queryInstance) {
    return this.lookupQueryInfo(queryInstance).observable;
  };

  RenderPromises.prototype.addQueryPromise = function (queryInstance, finish) {
    var info = this.lookupQueryInfo(queryInstance);

    if (!info.seen) {
      this.queryPromises.set(queryInstance, new Promise(function (resolve) {
        resolve(queryInstance.fetchData());
      }));
      return null;
    }

    return finish();
  };

  RenderPromises.prototype.hasPromises = function () {
    return this.queryPromises.size > 0;
  };

  RenderPromises.prototype.consumeAndAwaitPromises = function () {
    var _this = this;

    var promises = [];
    this.queryPromises.forEach(function (promise, queryInstance) {
      _this.lookupQueryInfo(queryInstance).seen = true;
      promises.push(promise);
    });
    this.queryPromises.clear();
    return Promise.all(promises);
  };

  RenderPromises.prototype.lookupQueryInfo = function (queryInstance) {
    var queryInfoTrie = this.queryInfoTrie;
    var _a = queryInstance.props,
        query = _a.query,
        variables = _a.variables;
    var varMap = queryInfoTrie.get(query) || new Map();
    if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
    var variablesString = JSON.stringify(variables);
    var info = varMap.get(variablesString) || makeDefaultQueryInfo();
    if (!varMap.has(variablesString)) varMap.set(variablesString, info);
    return info;
  };

  return RenderPromises;
}();

function getDataFromTree(tree, context) {
  if (context === void 0) {
    context = {};
  }

  return getMarkupFromTree({
    tree: tree,
    context: context,
    renderFunction: require("react-dom/server").renderToStaticMarkup
  });
}

function getMarkupFromTree(_a) {
  var tree = _a.tree,
      _b = _a.context,
      context = _b === void 0 ? {} : _b,
      _c = _a.renderFunction,
      renderFunction = _c === void 0 ? require("react-dom/server").renderToStaticMarkup : _c;
  var renderPromises = new RenderPromises();

  var RenderPromisesProvider = function (_super) {
    __extends(RenderPromisesProvider, _super);

    function RenderPromisesProvider() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    RenderPromisesProvider.prototype.getChildContext = function () {
      return __assign({}, context, {
        renderPromises: renderPromises
      });
    };

    RenderPromisesProvider.prototype.render = function () {
      return tree;
    };

    RenderPromisesProvider.childContextTypes = {
      renderPromises: object
    };
    return RenderPromisesProvider;
  }(Component);

  Object.keys(context).forEach(function (key) {
    RenderPromisesProvider.childContextTypes[key] = any;
  });

  function process() {
    var html = renderFunction(createElement(RenderPromisesProvider));
    return renderPromises.hasPromises() ? renderPromises.consumeAndAwaitPromises().then(process) : html;
  }

  return Promise.resolve().then(process);
}

function renderToStringWithData(component) {
  return getMarkupFromTree({
    tree: component,
    renderFunction: require("react-dom/server").renderToString
  });
}

function compose() {
  var funcs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    funcs[_i] = arguments[_i];
  }

  var functions = funcs.reverse();
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var firstFunction = functions[0],
        restFunctions = functions.slice(1);
    var result = firstFunction.apply(null, args);
    restFunctions.forEach(function (fnc) {
      result = fnc.call(null, result);
    });
    return result;
  };
}

export { ApolloConsumer, ApolloContext, ApolloProvider, Mutation, Query, RenderPromises, Subscription, compose, getDataFromTree, getMarkupFromTree, graphql, renderToStringWithData, withApollo, withMutation, withQuery, withSubscription };